import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-load-more',
    template: `
        <button
            mat-stroked-button
            class="spinner-button"
            [style.pointer-events]="disabled ? 'none' : ''"
            [disabled]="loading || disabled"
            [class.submitting]="loading"
            (mousedown)="$event.preventDefault()"
        >
            <span class="label">
                {{ label }}
            </span>
            <app-spinner-button-spinner *ngIf="loading"></app-spinner-button-spinner>
        </button>
    `,
    styleUrls: ['./load-more.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadMoreComponent
{
    // Customization

    @Input() protected label = 'View more';
    @Input() protected loading = false;

    @Input() protected disabled = false;
}
